import { Page } from '@/components';

import { Flex, Heading, WalletAddress } from '@blockanalitica/ui';
import HolderAmountKpiWithChart from './HolderAmountKpiWithChart';
import HolderEventsTable from './HolderEventsTable';
import { useParams } from 'react-router';

export default function StakingHolderPage() {
  const { wallet_address } = useParams() as {
    wallet_address: string;
  };

  return (
    <Page
      title={
        <WalletAddress
          gap="s"
          options={{
            showCopyBtn: true,
            showEthScanLink: true,
            showDebankLink: true,
            showZapperLink: true,
            sizes: {
              icon: '8',
              walletAddressHeader: '4'
            },
            network: 'ethereum'
          }}
          address={wallet_address}
        />
      }>
      <HolderAmountKpiWithChart walletAddress={wallet_address} />
      <Flex flexDirection="column" gap="xs">
        <Heading>Events</Heading>
        <HolderEventsTable walletAddress={wallet_address} />
      </Flex>
    </Page>
  );
}
